import styles from "./Fourth.module.css";
import Experience from "../components/experiences/Experience";

function Fourth({ experiencesRef }) {
  const experiences = [
    {
      id: "-1",
      title: "Visiting Researcher",
      mission: "Mission : Collaborate, conduct research, share knowledge, foster professional growth, and drive innovation.",
      goal: "Goals: Partner with researchers to design, develop, and publish innovative research projects",
      technologies:"Technologies : NLP tools, Python, Code-LLMs",
      period: "Feb 26 - July 26",
      image: "/images/experiences/KFUPM.svg",
      video: "",
    },
    {
      id: "0",
      title: "Visiting Researcher",
      mission: "Mission : Collaborate, conduct research, share knowledge, develop professionally, and innovate.",
      goal: "Goals : Collaborated with researchers to conduct, develop, and publish innovative research projects.",
      technologies:"Technologies : NLP tools, Python, HuggingFace",
      period: "Oct 24 - Mar 25",
      image: "/images/experiences/lu.png",
      video: "",
    },
    {
      id: "1",
      title: "Software engineer intern : End Of Studies Internship",
      mission: "Mission : Geographic information sharing platform development",
      goal: "Goals : Worked closely with senior software engineers to design, develop, test, and deploy a geographic information-sharing platform using Angular, FastAPI, and PostgreSQL.",
      technologies:"Technologies : Angular, FastAPI, PostgreSQL (PostGIS)",
      period: "January - June 2023",
      image: "/images/experiences/henceforth.png",
      video: "https://drive.google.com/file/d/14Y5wWri5TZ8eOph5V0HGh4Eh9zJXncAv/preview",
    },
    {
      id: "2",
      title: "Software engineer intern : Technical internship",
      mission: "Mission : A platform development for AlKhawarizmi program",
      goal: "Goals : introduce the program to the world, monitor the progress of searchers’ projects, and create an AI area for collaboration between enterprises and searchers.",
      technologies:"Technologies : Reactjs, Java (SpringBoot), MySQL",
      period: "July & August 2022",
      image: "/images/experiences/add.png",
      video:
        "https://drive.google.com/file/d/1rfiz2trVu-l5JVuCGNYk2SqiHG6qR5EH/preview",
    },
  ];

  return (
    <div ref={experiencesRef} className={styles.fourthsection}>
      <h1 className={styles.title}>03. Experiences</h1>
      <div className={styles.experiences}>
        {experiences.map((element) => (
          <Experience key={element.id} experience={element} />
        ))}
      </div>
    </div>
  );
}
export default Fourth;
